var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"card"},[_c('vue-tabs',{staticClass:"p-3 payments-mobile"},[_c('v-tab',{attrs:{"title":"Pagos Pendientes"}},[_c('TablePayments')],1),_c('v-tab',{attrs:{"title":"Pagos Completados"}},[_c('TableCompleteRewards')],1),_c('v-tab',{attrs:{"title":"Ordenes"}},[_c('TableOrders')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }